import { FC } from 'react';
import { CustomCard } from '@mybonum/ui';

import { PatientsFilter } from './components/filter';
import { PatientsTable } from './components/table';
import { useColumns } from './hooks/use-columns.tsx';
import { TPatientType } from './types.ts';

import { ColumnsVisibilityProvider } from '@/contexts/column-visibility';

export const Patients: FC = () => {
    const columns = useColumns();

    return (
        <CustomCard>
            <ColumnsVisibilityProvider<TPatientType>
                storageKey="patients_table"
                columns={columns}
                requiredColumnsKeys={['id', 'firstName']}
            >
                <PatientsFilter />
                <PatientsTable />
            </ColumnsVisibilityProvider>
        </CustomCard>
    );
};
